import { render } from "./OpenCameraMobile.vue?vue&type=template&id=4bc613d0"
import script from "./OpenCameraMobile.vue?vue&type=script&lang=js"
export * from "./OpenCameraMobile.vue?vue&type=script&lang=js"

import "./OpenCameraMobile.vue?vue&type=style&index=0&id=4bc613d0&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__